module.exports = "<div>\n  <iframe src=\"https://editor.noasy.com/\" style=\"width:100%;height:700px;border:none;\"></iframe>\n</div>\n"